import { useEffect, useState, useCallback } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';
import { validateTranslationParams, apiErrorMessage } from '../utils/translationParamValidation';

export const fetchTranslationTimeSeries = async (startDate, endDate, languages) => {
  const response = await api({
    method: 'post',
    url: `${QUALITY_SERVICE_API_URL}/hub/translation/time-series`,
    data: { startDate, endDate, languages },
  });
  return response.data;
};

const useTranslationTimeSeries = (startDate, endDate, languages) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setError(null);
    try {
      validateTranslationParams(startDate, endDate, languages);
      setLoading(true);
      const result = await fetchTranslationTimeSeries(startDate, endDate, languages);
      setData(result);
    } catch (err) {
      const message = err.status === 400 ? err.message : apiErrorMessage(err);
      setError(new Error(message));
      console.error('Failed to fetch translation time series:', err);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, languages]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error };
};

export default useTranslationTimeSeries;
